import { Directive, HostListener } from '@angular/core';

import { ScrollService } from './services/scroll/scroll.service';


@Directive({
  selector: '[appScrollDetect]'
})
export class ScrollDetectDirective {
  constructor(
    private scrollService: ScrollService
  ) {}

  @HostListener('scroll', ['$event'])
  onScroll(event: any) {
    this.scrollService.windowScroll.emit(event);
  }
}
